import cx from "classnames";
import { FC, HTMLAttributes, PropsWithChildren, memo } from "react";
import { Options, useInView } from "react-cool-inview";

interface IFadeInViewProps
  extends Options<HTMLDivElement>,
    Omit<HTMLAttributes<HTMLDivElement>, "onChange"> {
  transitionDelay?: number;
}

const FadeInView: FC<PropsWithChildren<IFadeInViewProps>> = ({
  children,
  className,
  delay,
  onChange,
  onEnter,
  onLeave,
  root,
  // Shrink the root margin, so the animation will be triggered once the target reach a fixed amount of visible
  rootMargin = "-200px 0px",
  threshold,
  trackVisibility,
  transitionDelay = 75,
  // Stop observe when the target enters the viewport, so the "inView" only triggered once
  unobserveOnEnter = true,
  ...rest
}) => {
  const { observe, inView } = useInView({
    delay,
    onChange,
    onEnter,
    onLeave,
    root,
    rootMargin,
    threshold,
    trackVisibility,
    unobserveOnEnter,
  });

  return (
    <div
      {...rest}
      ref={observe}
      className={cx(
        "rounded-3xl transition duration-1000",
        {
          "translate-y-0 scale-100 opacity-100": inView,
          "translate-y-20 scale-[98%] opacity-0": !inView,
        },
        className
      )}
      style={{
        transitionDelay: `${transitionDelay}ms`,
      }}
    >
      {children}
    </div>
  );
};

export default memo(FadeInView);
